import './less/basicSearchForm.less';

import {getWindowWidth} from "../../js/core/Helpers/Helpers";


const BasicSearchForm = function(){
    let selectors = {
        searchForm : document.querySelector('#js-basic-search-form'),
        closers : document.getElementsByClassName('js-search-close'),
        opener : document.querySelector('#js-search-opener')
    };
    
    
        const toggleSearchForm = e => {
            e.preventDefault();
            selectors.searchForm.classList.toggle('opened');
        };
        
        [...selectors.closers].map(closer => {
            closer ? closer.addEventListener('click', toggleSearchForm) : null;
        });
    
        
        selectors.opener ? selectors.opener.addEventListener('click', e => toggleSearchForm(e) ) : null;
    
        const moveSearch = () => {
            $(selectors.searchForm).insertAfter($('#topMenu'));
        };
    
        getWindowWidth() < 1199 ? moveSearch() : null;

    
};


export default BasicSearchForm;


// WEBPACK FOOTER //
// ./components/basicSearchForm/basicSearchForm.js